// extracted by mini-css-extract-plugin
module.exports = {"logoContainer":"logo_logoContainer__25FCn","medium":"logo_medium__2E0s7","large":"logo_large__3--K0"};